import { render, staticRenderFns } from "./AMLoginRootComponent.vue?vue&type=template&id=0e6b9ff6&scoped=true"
import script from "./AMLoginRootComponent.vue?vue&type=script&lang=js"
export * from "./AMLoginRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6b9ff6",
  null
  
)

export default component.exports